import classNames from "classnames";
import PropTypes from "prop-types";

const SwitchMembershipSectionWrapper = ({
   children,
   className,
}) => {


   return (
      <div
         className={ classNames({
            'w-full p-4 rounded-lg bg-grey-main': true,
            [`${ className }`]: Boolean(className),
         }) }
      >
         {children}
      </div>
   )
}

SwitchMembershipSectionWrapper.propTypes = {
   children: PropTypes.any,
   className: PropTypes.string,
}

export default SwitchMembershipSectionWrapper;
